import { useEffect, useMemo, useState } from 'react'
import type { Project } from '@/types/api'

const STORAGE_KEY = 'go-crm:project:scope'
const ALL_SCOPE = 'all'

export function useProjectScope(projects: Project[]) {
  const [scopeState, setScopeState] = useState<string>(() => {
    if (typeof window === 'undefined') return ALL_SCOPE
    return localStorage.getItem(STORAGE_KEY) || ALL_SCOPE
  })

  const scope = useMemo(() => {
    if (!projects.length) return scopeState
    const hasMatch = scopeState === ALL_SCOPE || projects.some((project) => project.id === scopeState)
    if (!hasMatch) {
      return projects[0].id
    }
    return scopeState
  }, [projects, scopeState])

  useEffect(() => {
    if (typeof window === 'undefined') return
    localStorage.setItem(STORAGE_KEY, scope)
  }, [scope])

  const setScope = (value: string) => {
    setScopeState(value)
    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, value)
    }
  }

  const selectedProject =
    scope === ALL_SCOPE ? null : projects.find((project) => project.id === scope) || null

  return {
    scope,
    selectedProject,
    setScope,
  }
}
